import { apiAxios as authAxios } from '../axios.config';

export const listCountries = () => {
    return authAxios.get('/api/country');
}